@if (record._id) {
  <div class="modal fade" id="edit-record-timesheet-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit timesheet</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #editRecordTimesheetForm="ngForm">
            <p>
              Add the hours you or your team members worked on this record.<br>
              You can use 0.5 to indicate 30 minutes.<br>
              To add or remove a team member here, you should edit the record's Team field.
            </p>
            <div class="d-flex flex-column flex-fill">
              @for (time of record.timesheet; track time; let index = $index) {
                <div class="form-group">
                  <label><b>{{time._user.firstName.substring(0,1)}}. {{time._user.lastName}}</b> hours <span class="text-danger small">(required)</span></label>
                  <input type="number" class="form-control" [name]="'hours_'+time._user._id" [(ngModel)]="time.hours" min="0" step="0.5" placeholder="10" required>
                </div>
              }
            </div>
            <p class="mt-1">
              The total number of hours is automatically calculated on save.
            </p>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateRecordTimesheet(record)"
            [disabled]="!editRecordTimesheetForm.form.valid || isModalInvalid()">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}